var _a;
export const glosbeUiServerUrlWithoutPath = `${location.protocol}//${location.host}`;
export const glosbeUiServerUrl = ((_a = window.glosbe) === null || _a === void 0 ? void 0 : _a.requestUrl) || `${location.protocol}//${location.host}${location.pathname}`;
//export const glosbeUiServerUrl = `http://localhost:8080/pl/en/kot`;
